// extracted by mini-css-extract-plugin
module.exports = {"button":"StyledButton_button__2iIZP","icon":"StyledButton_icon__Gu1zL","text":"StyledButton_text__KZgA6"};